import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
// TypeScript 5 rejects an import path ending in .ts (TS5097); angular.json loads the polyfills too
import './polyfills';

if (environment.production) {
    enableProdMode();
}

// @angular/platform-browser-dynamic is deprecated since Angular 20; AOT builds bootstrap through platformBrowser
platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] });
